import styled from 'styled-components';

import Text from '../Text';
import Spinner from 'react-bootstrap/Spinner';

const StyledButton = styled.button`
  border-radius: 6px;
  border-width: 0px;
  cursor: pointer;
  padding-left: ${({ paddingHorizontal }) =>
    paddingHorizontal !== undefined ? `${paddingHorizontal}px` : '24px'};
  padding-right: ${({ paddingHorizontal }) =>
    paddingHorizontal !== undefined ? `${paddingHorizontal}px` : '24px'};
  background-color: ${({ backgroundColor, theme }) =>
    backgroundColor
      ? theme.colors[backgroundColor]
      : theme.colors.primaryColor};
  color: ${({ color, theme }) =>
    color ? theme.colors[color] : theme.colors.buttonTextColor};
  height: ${({ height }) => (height ? `${height}px` : '44px')};
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  cursor: pointer;
  width: ${({ expand }) => (expand ? '100%' : 'auto')};
`;

const Button = (props) => {
  const {
    isLoading,
    children,
    onClick,
    disabled,
    backgroundColor,
    titleColor,
    textStyle,
    ...other
  } = props;

  const handleClick = () => {
    if (!disabled && typeof onClick === 'function') {
      onClick();
    }
  };

  return (
    <StyledButton
      onClick={handleClick}
      backgroundColor={disabled ? 'disabledButtonColor' : backgroundColor}
      {...other}
    >
      {isLoading ? (
        <div
          style={{
            display: 'flex',
            height: '100%',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spinner animation="border" role="status" size="sm">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <Text variant="button" color={titleColor} {...textStyle}>
          {children}
        </Text>
      )}
    </StyledButton>
  );
};

Button.defaultProps = {
  titleColor: 'buttonTextColor',
  textStyle: {},
};

export default Button;
